import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import {
  setAccessToken,
  setIdToken,
  clearAccessToken,
} from 'lib/auth/tokenStore';

const TokenSync = () => {
  const auth = useAuth();

  useEffect(() => {
    if (auth.user?.access_token) {
      setAccessToken(auth.user.access_token, auth.user.expires_at);
      setIdToken(auth.user.id_token);
    } else {
      clearAccessToken();
    }
  }, [auth.user]);

  return null;
};

export default TokenSync;
